import { Component, HostListener, Input, OnChanges } from '@angular/core';
import * as echarts from 'echarts';

@Component({
  selector: 'app-bar',
  templateUrl: './bar.component.html',
  styleUrls: ['./bar.component.css']
})
export class BarComponent implements OnChanges {
  chartOption: any;
  noData: boolean = false;

  @Input() barChartData: any;
  @HostListener('window:resize', ['$event'])
  onResize() {
    let chart = echarts?.init(document.getElementById('barCharts'));
    setTimeout(() => {
      chart.resize();
    }, 1);
  }
  constructor() { }

  ngOnChanges(): void {
    if (this.barChartData) {
      this.plotBar();
    }else{
      this.noData = true;
    }
  }

  /**
   * Plots bar
   */
  plotBar() {
    this.chartOption = {
      tooltip: {
        trigger: 'axis'
      },
      grid: this.barChartData['grid'],
      xAxis: {
        type: this.barChartData?.type,
        data: this.barChartData?.barXaxisData,
        name: this.barChartData?.xAxisLabel ? this.barChartData?.xAxisLabel : '',
        nameLocation: this.barChartData?.yNameLocation ? this.barChartData?.yNameLocation : 'middle',
        nameTextStyle: {
          fontFamily: 'Inter',
          fontSize: 12,
          fontWeight: 400,
          color: '#9291A5'
        },
        axisTick: {
          show: this.barChartData?.xAxisTick ? this.barChartData?.xAxisTick : false
        },
        splitLine: {
          show: this.barChartData.splitLine, // Show grid lines
        },
        nameGap: 40
      },
      yAxis: {
        type: 'value',
        name: this.barChartData?.yAxisLabel ? this.barChartData?.yAxisLabel : '',
        nameLocation: this.barChartData?.yNameLocation ? this.barChartData?.yNameLocation : 'middle',
        nameTextStyle: {
          fontFamily: 'Inter',
          fontSize: 12,
          fontWeight: 400,
          color: '#9291A5'
        },
        axisTick: {
          show: this.barChartData?.yAxisTick ? this.barChartData?.yAxisTick : false
        },
        axisLabel: {
          show: !this.barChartData?.yaxisLabelShow ? false : true
        },
        splitLine: {
          show: false, // Show grid lines
        },
      },
      color: this.barChartData?.color ? this.barChartData?.color : [],
      series: [
        {
          data: this.barChartData?.barData,
          type: 'bar',
          barWidth: this.barChartData?.barWidth ? this.barChartData?.barWidth : null,
          itemStyle: {
            borderRadius: [3, 3, 0, 0]  // Top-left, top-right, bottom-right, bottom-left
          }
        }
      ]
    };
  }

}
